import { render, staticRenderFns } from "./EditDetails.vue?vue&type=template&id=3198d868&lang=html&"
import script from "./EditDetails.vue?vue&type=script&lang=js&"
export * from "./EditDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports